import { DialogContent, DialogContentText, Typography } from '@mui/material';
import clsx from 'clsx';
import { t } from 'i18next';
import CustomCheckbox from '../../../ui-components/checkbox.component';
import { sharedStyles } from './shared-styles';

export const DoNotShowAgainCheckbox = ({
  checked,
  handleCheckboxChange,
}: {
  checked: boolean;
  handleCheckboxChange: (checked: boolean) => void;
}) => {
  const classes = sharedStyles();
  return (
    <DialogContent classes={{ root: clsx(classes.checkboxDialogContentRoot) }}>
      <DialogContentText classes={{ root: classes.displayFlex }} component='div'>
        <CustomCheckbox
          style={{ padding: '0px 8px 0px 0px' }}
          color='primary'
          checked={checked}
          onChange={(event) => handleCheckboxChange(event.target.checked)}
          name='unlicensed_charger_checkbox'
        />
        <Typography className={classes.checkBoxTypography}>
          {t('unlicensed_charger_popup_checkbox')}
        </Typography>
      </DialogContentText>
    </DialogContent>
  );
};
